import React from 'react'

function CallToAction() {
    return (
        <div>

            {/* cta section start */}
            <div className="rts-cta-section-start rts-section-gap cta-bg-h2">
                <div className="container">
                    <div className="row">
                        <div className="cta-h2-wrapper text-center">
                            <div className="icon">
                                <a href="#">
                                    <i className="fas fa-phone-alt" />
                                </a>
                            </div>
                            <div className="body">
                                <p className="info">
                                    Contact Our Agent For Any kind off Business Help{" "}
                                    <span>(24/7 Available)</span>
                                </p>
                                <a href="tel:123-456-7890p123" className="number">
                                    +215 2153.2159
                                </a>
                                <a href="#" className="rts-btn btn-primary-2">
                                    Contact Us
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default CallToAction